import { render, staticRenderFns } from "./LicenceTable.vue?vue&type=template&id=50a85193"
import script from "./LicenceTable.vue?vue&type=script&lang=js"
export * from "./LicenceTable.vue?vue&type=script&lang=js"
import style0 from "./LicenceTable.vue?vue&type=style&index=0&id=50a85193&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports